import { render, staticRenderFns } from "./ShareholdersPanel.vue?vue&type=template&id=bd4f31e0&scoped=true&"
import script from "./ShareholdersPanel.vue?vue&type=script&lang=js&"
export * from "./ShareholdersPanel.vue?vue&type=script&lang=js&"
import style0 from "./ShareholdersPanel.vue?vue&type=style&index=0&id=bd4f31e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4f31e0",
  null
  
)

export default component.exports